import React, { useEffect, useRef, useState } from 'react';

export default function ImgCarousel({ images }) {
  const [active, setActive] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const intervalRef = useRef(null);

  const next = () => setActive((active + 1) % images.length);
  const prev = () => setActive((active - 1 + images.length) % images.length);

  useEffect(() => {
    if (!isPaused) {
      intervalRef.current = setInterval(() => {
        next();
      }, 3000);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [active, isPaused]);

  const handleMouseEnter = () => setIsPaused(true);
  const handleMouseLeave = () => setIsPaused(false);

  return (
    <div 
      className="w-full flex flex-col items-center py-8 sm:py-12"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="relative w-full max-w-6xl flex items-center justify-center px-4 sm:px-8">

        {/* Left Arrow */}
        <button
          onClick={prev}
          className="absolute left-2 sm:left-4 z-10 bg-gray-800 text-white rounded-full p-2 sm:p-3 shadow hover:bg-black transition"
        >
          &lt;
        </button>

        {/* Carousel */}
        <div className="relative w-full flex justify-center items-center h-[260px] sm:h-[320px] md:h-[400px] lg:h-[500px]">
          {images.map((src, index) => {
            const offset = index - active;
            let className = 'absolute transition-all duration-500 ease-in-out';

            if (offset === 0) {
              className += ' scale-100 z-20';
            } else if (offset === -1 || (offset === images.length - 1 && active === 0)) {
              className += ' hidden sm:block scale-75 -translate-x-[150px] sm:-translate-x-[200px] md:-translate-x-[200px] lg:-translate-x-[250px]z-10';
            } else if (offset === 1 || (offset === -(images.length - 1) && active === images.length - 1)) {
              className += ' hidden sm:block scale-75 translate-x-[150px] sm:translate-x-[200px] md:translate-x-[200px] lg:translate-x-[250px] z-10';
            } else {
              className += ' scale-50 opacity-0';
            }

            return (
              <img
                key={index}
                src={src.image}
                alt={`Slide ${index}`}
                className={`${className} w-[200px] sm:w-[250px] md:w-[260px] lg:w-[350px] h-[300px] sm:h-[350px] md:h-[380px] lg:h-[480px] object-cover rounded-xl shadow-lg`}
              />
            );
          })}
        </div>

        {/* Right Arrow */}
        <button
          onClick={next}
          className="absolute right-2 sm:right-4 z-10 bg-gray-800 text-white rounded-full p-2 sm:p-3 shadow hover:bg-black transition"
        >
          &gt;
        </button>
      </div>
    </div>
  );
}
